export class IlpData<T> {
  private Role: string | undefined;
  private Data: T | null;

  constructor(role: string | undefined, data: T | null) {
    this.Role = role;
    this.Data = data;
  }
}
